export default __webpack_public_path__ + "static/media/feather_info.0cd2499a.svg";